import styled from "styled-components";

export const FraudmeterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
  width: 230px;
  margin: 15px 0;
  padding: 0;
  .fraudmeter {
    position: relative;
    overflow: hidden;
    height: 110px;
    background: #f1f1f1;
    width: 219px;
    #mask {
      position: relative;
    }
    #meter {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .value {
    color: #6a6a6a;
    font-weight: 800;
    font-size: 2.25rem;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 3.5ch;
    overflow: hidden;
  }
  .not-found {
    color: #6a6a6a;
    font-weight: 400;
    font-size: 20px;
    position: absolute;
    text-align: center;
    top: 60%;
    width: 8.5ch;
    overflow: wrap;
  }
  .title {
    font-weight: 800;
    color: #6a6a6a;
    margin-bottom: 22px;
  }
  .subtitle {
    font-size: 12px;
    color: #6a6a6a;
  }
  span {
    text-transform: uppercase;
    color: #333;
    top: 90px;
  }
  small {
    text-transform: uppercase;
    position: absolute;
    font-weight: 500;
    color: #6a6a6a;
    top: 77%;
  }
`;
